module.exports = __webpack_public_path__ + "2d420e398df2f9460843479d14526be0.woff2";